<template>

  <v-container>

    <v-alert
      dense
      text
      type="success"
      v-if="message"
    >
    {{message}}
    </v-alert>

    <v-alert
      dense
      text
      type="warning"
      v-if="isDuplicate"
    >
    そのURLはすでに登録されています
    </v-alert>

    <template>
      <v-tabs
        v-model="tab"
        fixed-tabs
        icons-and-text
      >
        <v-tab href="#online">オンラインで聴く<v-icon>mdi-equalizer</v-icon></v-tab>
        <v-tab href="#cd">CDで聴く<v-icon>mdi-headphones</v-icon></v-tab>
        <v-tab href="#live">ライブで聴く<v-icon>mdi-music</v-icon></v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item value="online">

          <v-row class="text-center">

            <v-col>

              <!-- <template>
                <form>
                  <v-text-field
                    v-model="inputUrl"
                    label="URLを入力してください"
                    required
                    clearable
                    @change="changeInputUrl"
                  ></v-text-field>

                  <v-btn
                    class="mr-4"
                    v-on:click="submit(inputUrl)"
                  >
                    登録する
                  </v-btn>
                </form>
              </template> -->

              <p v-if="Object.keys(articles).length > 0"
                class="subheading font-weight-regular mt-6">
                現在登録されているオンラインコンテンツは{{Object.keys(articles).length}}件です。
              </p>
              <p v-else
                class="subheading font-weight-regular mt-6">
                読み込み中です。。。
              </p>

            </v-col>

          </v-row>

          <template>
            <v-container fluid>

              <v-row align="center">
                <v-col
                  class="d-flex justify-center"
                  cols="12"
                  sm="3"
                />
                <v-col
                  cols="12"
                  sm="4">
                  <v-combobox
                    v-model="selectedArtists"
                    :items="artists"
                    label="アーティスト名を選択"
                    multiple
                    clearable
                    chips
                    @change="filterArticles"
                  ></v-combobox>
                </v-col>
                <v-col
                  class="d-flex justify-center"
                  cols="12"
                  sm="2"
                >
                  <v-select
                    :items="sortItems"
                    label="並び順"
                    @change="changedValue"
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
          </template>

          <v-row class="text-center">

            <!-- max-width="374" -->
            <v-card
              class="mx-auto my-1 col-lg-3 col-md-4 col-sm-12"
              max-width="374"
              v-for="(article, index) in articles"
              :key="index"
              >
              <!-- :loading="loading" -->

              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-img
                v-if="article.siteName !=='Facebook' && article.siteName !=='Twitter'"
                height="190"
                :src="article.ogimage"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <div v-if="article.siteName ==='Twitter'">
                <Tweet :id="getTweetId(article.url)"
                  error-message="This tweet could not be loaded"
                  error-message-class="tweet--not-found">
                  <div class="spinner"></div>
                </Tweet>
              </div>
              <div v-if="article.siteName ==='Facebook' && !isLocalhost()">
                <div class="fb-post" :data-href="article.url" data-width="330"></div>
              </div>

              <v-card-text>
                <div v-if="article.publishedAt">{{getPublishedAt(article.publishedAt)}}</div>

                <p
                  v-if="article.siteName !=='Facebook' && article.siteName !=='Twitter'"
                  class="text-h6 text-primary">
                  {{article.title}}
                </p>

                <p v-if="article.siteName && article.siteName !=='Twitter'">{{article.siteName}}</p>

                <div v-if="article.siteName ==='note'">
                  {{adjustLength(parseHtml(article.description))}}
                </div>
                <div v-else>
                  {{adjustLength(article.description)}}
                </div>

                <p class="text-body2 my-2" v-if="article.duration">
                  再生時間: {{getDuration(article.duration)}}
                </p>

              </v-card-text>

              <!-- <v-chip
                link
                class="ma-1"
                v-for="tag in article.tags"
                :key="tag">
                #{{tag}}
              </v-chip> -->

              <template>
                <v-combobox
                  v-model="article.tags"
                  label="アーティスト名"
                  :items="artists"
                  clearable
                  dense
                  multiple
                  @change="setArtist(article, index)"
                >
                <!-- label="Your favorite hobbies" -->
                <!-- prepend-icon="mdi-filter-variant" -->
                  <template v-slot:selection="{ attrs, item, select, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      @click="select"
                      @click:close="remove(item)"
                    >
                      {{ item }}&nbsp;
                      <!-- <strong>{{ item }}</strong>&nbsp; -->
                      <!-- <span>(interest)</span> -->
                    </v-chip>
                  </template>
                </v-combobox>
              </template>

              <v-switch
                inset
                @click="getSelectedItem(article.id, index)"
                @change="valueChange"
                v-if="article.siteName !=='Facebook' && article.siteName !=='Twitter'"
                :input-value="article.isFree"
                :label="`これは有料ですか？: ${getItemValue(article.isFree)}`"
              ></v-switch>

              <v-btn
                v-if="article.siteName !=='Twitter'"
                :href="article.url"
                target="_blank"
                block>
                  開く
              </v-btn>

            </v-card>

          </v-row>

        </v-tab-item>
        <v-tab-item value="cd">

          <v-row class="text-center mt-6">

            <!-- Cranking Out -->
            <v-card
              class="mx-auto my-1 col-lg-3 col-md-4 col-sm-6 col-xs-12"
              >

              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-img
                src="/artwork/crankingout.jpg"
              >
              </v-img>

              <v-card-title>Cranking Out</v-card-title>

              <v-card-subtitle>
                O’Jizo
              </v-card-subtitle>

              <v-card-text>
                収録時間: 42 分<br/>
                発売日: 2019/2/24<br/>
                レーベル: TOKYO IRISH COMPANY<br/>
                <!-- ASIN: B07N1RP3H3<br/>
                JAN： 4562397360199<br/> -->
              </v-card-text>

              <v-btn
                class="my-1"
                href="https://www.kozo-toyota.com/2019/11/22/ojizo-cranking-out/"
                target="_blank"
                block>
                  公式ウェブサイト
              </v-btn>
              <v-btn
                class="my-1"
                href="https://www.amazon.co.jp/dp/B07N1RP3H3/ref=cm_sw_r_tw_dp_U_x_rm51Db4Y2B34Q"
                target="_blank"
                block>
                  Amazon
              </v-btn>
            </v-card>

            <!-- Shadows and Silhouettes -->
            <v-card
              class="mx-auto my-1 col-lg-3 col-md-4 col-sm-6 col-xs-12"
              >

              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-img
                src="/artwork/shadows-and-silhouettes.jpg"
              >
              </v-img>

              <v-card-title>Shadows and Silhouettes</v-card-title>

              <v-card-subtitle>
                Dai Komatsu & Tetsuya Yamamoto
              </v-card-subtitle>

              <v-card-text>
                発売日: 2018年9月20日<br/>
                <!-- レーベル: TOKYO IRISH COMPANY<br/>
                収録時間: 42 分<br/> -->
                <!-- ASIN: B07N1RP3H3<br/>
                JAN： 4562397360199<br/> -->
              </v-card-text>

              <v-btn
                class="my-1"
                href="https://odeinc.stores.jp/items/5edb271434ef015b774a6aeb"
                target="_blank"
                block>
                  公式ウェブサイト
              </v-btn>
            </v-card>

            <!-- NISHIKOKU P.M.2:30 -->
            <v-card
              class="mx-auto my-1 col-lg-3 col-md-4 col-sm-6 col-xs-12"
              >

              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-img
                src="https://p1-e6eeae93.imageflux.jp/c!/f=webp:auto,lossless=1,a=2,w=920,h=920,b=ffffff00/odeinc/d2dd4598e713351e703a.png"
              >
              </v-img>

              <v-card-title>NISHIKOKU P.M.2:30</v-card-title>

              <v-card-subtitle>
                小松大&高橋創
              </v-card-subtitle>

              <v-card-text>
                発売日: 2018年11月<br/>
                <!-- レーベル: TOKYO IRISH COMPANY<br/>
                収録時間: 42 分<br/> -->
                <!-- ASIN: B07N1RP3H3<br/>
                JAN： 4562397360199<br/> -->
              </v-card-text>

              <v-btn
                class="my-1"
                href="https://odeinc.stores.jp/items/5edb27ec55fa033d7c463e0f"
                target="_blank"
                block>
                  公式ウェブサイト
              </v-btn>
            </v-card>

            <!-- Thousands of Flowers -->
            <v-card
              class="mx-auto my-1 col-lg-3 col-md-4 col-sm-6 col-xs-12"
              >

              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-img
                src="/artwork/thousands-of-flowers.jpg"
              >
              </v-img>

              <v-card-title>Thousands of Flowers</v-card-title>

              <v-card-subtitle>
                須貝知世
              </v-card-subtitle>

              <v-card-text>
                <!-- レーベル: TOKYO IRISH COMPANY<br/> -->
                収録時間: 38:49<br/>
                発売日: 2018.09.02<br/>
                発売元：TOKYO IRISH COMPANY<br/>
                <!-- ASIN: B07N1RP3H3<br/> -->
                <!-- JAN： 4562397360182<br/> -->
              </v-card-text>

              <v-btn
                class="my-1"
                href="http://www.tomoyosugai.com/thousands-of-flowers/"
                target="_blank"
                block>
                  特設サイト
              </v-btn>
              <v-btn
                class="my-1"
                href="https://soundcloud.com/tomoyo-sugai/sets/thousands-of-flowers/s-Y1Igc"
                target="_blank"
                block>
                  視聴する
              </v-btn>
              <v-btn
                class="my-1"
                href="http://metacompany.jp/shop/index.php?main_page=product_info&cPath=9_674&products_id=1308"
                target="_blank"
                block>
                  購入する
              </v-btn>
            </v-card>

            <!-- Internal Circulation —呼吸の巴— -->
            <v-card
              class="mx-auto my-1 col-lg-3 col-md-4 col-sm-6 col-xs-12"
              >

              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-img
                src="/artwork/internal-circulation.jpg"
              >
              </v-img>

              <v-card-title>Internal Circulation —呼吸の巴—</v-card-title>

              <v-card-subtitle>
                豊田 耕三
              </v-card-subtitle>

              <v-card-text>
                収録時間: 68 分<br/>
                発売日: 2018/3/11<br/>
                レーベル: TOKYO IRISH COMPANY<br/>
                <!-- JAN： 4562397360175<br/>
                ASIN: B079FLYHSB<br/> -->
              </v-card-text>

              <!-- v-if="article.siteName !=='Twitter'"
              :href="article.url" -->
              <v-btn
                class="my-1"
                href="https://www.kozo-toyota.com/2018/03/20/%E8%B1%8A%E7%94%B0-%E8%80%95%E4%B8%89-internal-circulation-%E5%91%BC%E5%90%B8%E3%81%AE%E5%B7%B4/"
                target="_blank"
                block>
                  公式ウェブサイト
              </v-btn>
              <v-btn
                class="my-1"
                href="https://www.amazon.co.jp/dp/B079FLYHSB/ref=cm_sw_r_tw_dp_U_x_VB41DbH5C7ATK"
                target="_blank"
                block>
                  Amazon
              </v-btn>
            </v-card>

            <!-- Gathering Cloud -->
            <v-card
              class="mx-auto my-1 col-lg-3 col-md-4 col-sm-6 col-xs-12"
              >

              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-img
                src="/artwork/gathering-cloud.jpg"
              >
              </v-img>

              <v-card-title>Gathering Cloud</v-card-title>

              <v-card-subtitle>
                Toyota Ceili Band
              </v-card-subtitle>

              <v-card-text>
                収録時間: 42 分<br/>
                発売日: 2017/4/9<br/>
                レーベル: TOKYO IRISH COMPANY<br/>
                <!-- JAN： 4562397360168<br/>
                ASIN: B06XS9BMCV<br/> -->
              </v-card-text>

              <!-- v-if="article.siteName !=='Twitter'"
              :href="article.url" -->
              <v-btn
                class="my-1"
                href="https://www.kozo-toyota.com/2018/03/20/toyota-ceili-band-gathering-cloud/"
                target="_blank"
                block>
                  公式ウェブサイト
              </v-btn>
              <v-btn
                class="my-1"
                href="https://www.amazon.co.jp/Gathering-Cloud-Toyota-Ceili-Band/dp/B06XS9BMCV/ref=pd_rhf_dp_s_cp_0_6"
                target="_blank"
                block>
                  Amazon
              </v-btn>
            </v-card>

            <!-- Via Portland -->
            <v-card
              class="mx-auto my-1 col-lg-3 col-md-4 col-sm-6 col-xs-12"
              >

              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-img
                src="/artwork/via-portland.jpg"
              >
              </v-img>

              <v-card-title>Via Portland</v-card-title>

              <v-card-subtitle>
                O’Jizo
              </v-card-subtitle>

              <v-card-text>
                収録時間: 61 分<br/>
                発売日: 2017/3/5<br/>
                レーベル: TOKYO IRISH COMPANY<br/>
                <!-- ASIN: B01MUWJXKN<br/>
                JAN： 4562397360144<br/> -->
              </v-card-text>

              <v-btn
                class="my-1"
                href="https://www.kozo-toyota.com/2018/03/20/ojizo-via-portland/"
                target="_blank"
                block>
                  公式ウェブサイト
              </v-btn>
              <v-btn
                class="my-1"
                href="https://www.amazon.co.jp/Via-Portland-OJizo/dp/B01MUWJXKN/ref=sr_1_1"
                target="_blank"
                block>
                  Amazon
              </v-btn>
            </v-card>

            <!-- Years -->
            <v-card
              class="mx-auto my-1 col-lg-3 col-md-4 col-sm-6 col-xs-12"
              >

              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-img
                src="/artwork/years.jpg"
              >
              </v-img>

              <v-card-title>Years</v-card-title>

              <v-card-subtitle>
                Dai Komatsu & Tetsuya Yamamoto
              </v-card-subtitle>

              <v-card-text>
                発売日: 2016年9月<br/>
                <!-- レーベル: TOKYO IRISH COMPANY<br/>
                収録時間: 42 分<br/> -->
                <!-- ASIN: B07N1RP3H3<br/>
                JAN： 4562397360199<br/> -->
              </v-card-text>

              <v-btn
                class="my-1"
                href="https://odeinc.stores.jp/items/5edb26b8cee9ea637c151371"
                target="_blank"
                block>
                  公式ウェブサイト
              </v-btn>
            </v-card>

            <!-- Black & Olive 1st Album''Black Tide'' -->
            <v-card
              class="mx-auto my-1 col-lg-3 col-md-4 col-sm-6 col-xs-12"
              >

              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-img
                src="/artwork/black-tide.jpg"
              >
              </v-img>

              <v-card-title>Black & Olive 1st Album''Black Tide''</v-card-title>

              <v-card-subtitle>
                Dai Komatsu & Tetsuya Yamamoto
              </v-card-subtitle>

              <v-card-text>
                発売日: 2015年<br/>
                <!-- レーベル: TOKYO IRISH COMPANY<br/>
                収録時間: 42 分<br/> -->
                <!-- ASIN: B07N1RP3H3<br/>
                JAN： 4562397360199<br/> -->
              </v-card-text>

              <v-btn
                class="my-1"
                href="https://odeinc.stores.jp/items/5edb28cf55fa0328944641a4"
                target="_blank"
                block>
                  公式ウェブサイト
              </v-btn>
            </v-card>

            <!-- Highlight -->
            <v-card
              class="mx-auto my-1 col-lg-3 col-md-4 col-sm-6 col-xs-12"
              >

              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-img
                src="/artwork/highlight.jpg"
              >
              </v-img>

              <v-card-title>Highlight</v-card-title>

              <v-card-subtitle>
                O’Jizo
              </v-card-subtitle>

              <v-card-text>
                収録時間: 61 分<br/>
                発売日: 2011/10/2<br/>
                レーベル: TOKYO IRISH COMPANY<br/>
                <!-- ASIN: B005LD6SA2<br/>
                JAN： 4540862900309<br/> -->
              </v-card-text>

              <v-btn
                class="my-1"
                href="https://www.kozo-toyota.com/2018/03/20/ojizo-highlight/"
                target="_blank"
                block>
                  公式ウェブサイト
              </v-btn>
              <v-btn
                class="my-1"
                href="https://www.amazon.co.jp/Highlight-%E2%80%99Jizo/dp/B005LD6SA2/ref=sr_1_3"
                target="_blank"
                block>
                  Amazon
              </v-btn>
            </v-card>

            <!-- Tokyo Irish Generation｜Compilation -->
            <v-card
              class="mx-auto my-1 col-lg-3 col-md-4 col-sm-6 col-xs-12"
              >

              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-img
                src="/artwork/tokyo-irish-generation.jpg"
              >
              </v-img>

              <v-card-title>Tokyo Irish Generation｜Compilation</v-card-title>

              <!-- <v-card-subtitle>
                O’Jizo
              </v-card-subtitle> -->

              <v-card-text>
                収録時間: 45 分<br/>
                発売日: 2010/8/25<br/>
                レーベル: スザクミュージック<br/>
                <!-- ASIN: B005LD6SA2<br/>
                JAN： 4540862900309<br/> -->
              </v-card-text>

              <!-- <v-btn
                class="my-1"
                href=""
                target="_blank"
                block>
                  公式ウェブサイト
              </v-btn> -->
              <v-btn
                class="my-1"
                href="https://www.amazon.co.jp/TOKYO-IRISH-GENERATION-%E3%82%AA%E3%83%A0%E3%83%8B%E3%83%90%E3%82%B9/dp/B003TOAXR4/ref=sr_1_1"
                target="_blank"
                block>
                  Amazon
              </v-btn>
            </v-card>

          </v-row>

        </v-tab-item>
        <v-tab-item value="live">

          <p class="subheading font-weight-regular my-6 text-center">
            ライブ情報は各アーティストのSNS、ホームページをご確認ください。
          </p>

          <v-row class="mt-6">

            <template>
              <v-card
                class="mx-auto my-1"
                max-width="344"
              >
                <v-card-text>
                  <div>Genya Ishizaki</div>
                  <p class="display-1 text--primary">
                    石崎元弥
                  </p>
                  <p>バウロン、ドラム</p>
                  <div class="text--primary">
                    アイルランドのダンスの伴奏専門のToyota Ceili Band
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    href="https://twitter.com/21cn1dr_g"
                    target="_blank"
                    text
                    color="deep-purple accent-4"
                  >
                    Twitter
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>

            <template>
              <v-card
                class="mx-auto my-1 col-12"
                max-width="344"
              >
                <v-card-text>
                  <div>Shima Ohashi</div>
                  <p class="display-1 text--primary">
                    大橋志麻
                  </p>
                  <p>アイリッシュハープ</p>
                  <div class="text--primary">
                    ハープとフルートのデュオFiona。
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    href="https://www.instagram.com/celticharp_shima/"
                    target="_blank"
                    text
                    color="deep-purple accent-4"
                  >
                    Instagram
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>

            <template>
              <v-card
                class="mx-auto my-1"
                max-width="344"
              >
                <v-card-text>
                  <div>Dai Komatsu</div>
                  <p class="display-1 text--primary">
                    小松大
                  </p>
                  <p>フィドル、ビオラ</p>
                  <div class="text--primary">
                    アイルランド音楽を奏でるデュオDai Komatsu & Tetsuya Yamamoto、 ''音楽のある暮らし''をテーマにひとびとへワクワクする時間を届けるOde.inc
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    href="https://www.facebook.com/ViolaDaiKomatsu/"
                    target="_blank"
                    text
                    color="deep-purple accent-4"
                  >
                    Facebook
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>

            <template>
              <v-card
                class="mx-auto my-1"
                max-width="344"
              >
                <v-card-text>
                  <div>Tomoyo Sugai</div>
                  <p class="display-1 text--primary">
                    須貝知世
                  </p>
                  <p>アイリッシュフルート、ティンホイッスル</p>
                  <div class="text--primary">
                    アイルランド・北欧の伝統音楽を演奏するna ba na、アイルランドのダンスの伴奏専門のToyota Ceili Band
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    href="https://twitter.com/tomoyosugai"
                    target="_blank"
                    text
                    color="deep-purple accent-4"
                  >
                    Twitter
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>

            <template>
              <v-card
                class="mx-auto my-1"
                max-width="344"
              >
                <v-card-text>
                  <div>Hajime Takahashi</div>
                  <p class="display-1 text--primary">
                    高橋創
                  </p>
                  <p>アイリッシュギター、アイリッシュテナーバンジョー</p>
                  <!-- <div class="text--primary">

                  </div> -->
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    href="https://twitter.com/hajimeruhajime"
                    target="_blank"
                    text
                    color="deep-purple accent-4"
                  >
                    Twitter
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>

            <template>
              <v-card
                class="mx-auto my-1"
                max-width="344"
              >
                <v-card-text>
                  <div>Harumi Takziawa</div>
                  <p class="display-1 text--primary">
                    瀧澤晴美
                  </p>
                  <p>アイリッシュフルート、ティンホイッスル</p>
                  <div class="text--primary">
                    ハープとフルートのデュオFiona、BB Céilí Band
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    href="https://twitter.com/fl_harumi"
                    target="_blank"
                    text
                    color="deep-purple accent-4"
                  >
                    Twitter
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>

            <template>
              <v-card
                class="mx-auto my-1"
                max-width="344"
              >
                <v-card-text>
                  <div>Kozo Toyata</div>
                  <p class="display-1 text--primary">
                    豊田耕三
                  </p>
                  <p>アイリッシュフルート、ティンホイッスル</p>
                  <div class="text--primary">
                    アイリッシュ・ミュージックのインストルメンタル・バンド O’Jizo、アイルランドのダンスの伴奏専門のToyota Ceili Band
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    href="https://lin.ee/xZBeAdB"
                    target="_blank"
                    text
                    color="deep-purple accent-4"
                  >
                    LINE公式アカウント
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>

          </v-row>

        </v-tab-item>
      </v-tabs-items>
    </template>

    <v-layout class="mt-6">
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-layout>
            <v-flex xs5>
              <v-img
                :src="publicPath + 'ogimage.jpg'"
                contain
                class="pl-4"
              ></v-img>
            </v-flex>
            <v-flex xs7>
              <v-card-title primary-title>
                <div>
                  <div class="headline">LINE公式アカウントやってます</div>
                  <!-- <div>お知らせを通知するよ</div> -->
                </div>
              </v-card-title>
              <v-card-actions>
                <v-btn
                  href="https://t.co/bpBeewt0vR"
                  target="_blank"
                  Block Button
                  color="orange">友達になる</v-btn>
              </v-card-actions>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <div class="text-center mt-6">
      <a href="https://twitter.com/share?ref_src=twsrc%5Etfw" class="twitter-share-button" data-text="アシオト - 日本のアイルランド音楽をオンラインで" data-url="https://ashioto-315.web.app/" data-via="アシオト" data-hashtags="アシオト" data-show-count="false" data-size="large">Tweet</a>
    </div>

    <!-- <v-row class="text-center my-6">
      <div class="col fb-page" data-href="https://www.facebook.com/ashioto0315/" data-tabs="timeline" data-width="" data-height="" data-small-header="false" data-adapt-container-width="false" data-hide-cover="true" data-show-facepile="true"><blockquote cite="https://www.facebook.com/ashioto0315/" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/ashioto0315/" target="_blank">アシオト連絡室</a></blockquote></div>
    </v-row> -->

  </v-container>
</template>

<script>

  import {db} from '../db.js'
  // import {twitterAPIInfo} from '../twitter.js'
  import YouTube from 'youtube-node'
  import moment from 'moment'

  moment.locale("ja")

  const youtubeKey = 'AIzaSyBcQy1t6Bzl9mXtTMtNtb2aCaQfiyJlFbw'
  const youtube = new YouTube()
  youtube.setKey(youtubeKey)

  import { Tweet } from 'vue-tweet-embed'

  // InstagramグラフAPI
  // https://developers.facebook.com/docs/instagram-api/?locale=ja_JP

  export default {
    name: 'HelloWorld',
    components: {
      Tweet
    },
    data: () => ({
      publicPath: process.env.BASE_URL,
      tab: "",
      sortItems: ['登録順', '公開日順'],
      isSelectedArticleFree: null,
      db: null,
      urls: {},
      inputUrl: "",
      message: "",
      isDuplicate: false,
      originalArticles: [],
      articles: [],
      selectedArtists: [],
      artists: [
        '大橋志麻',
        '石崎元弥',
        '小松大',
        '須貝知世',
        '高橋創',
        '瀧澤晴美',
        '豊田耕三'],
    }),
    created () {
      // Initialize Firebase

      let self = this
      db.ref('/articles').orderByChild('timestamp').once('value').then(function (articles) {
        // 素パースだと順序が決め打ちになってしまう
        // self.articles = articles.val()
        let _articles = articles.val()
        for (let index in _articles) {
          self.articles.push(_articles[index])
        }

        self.articles = self.articles.reverse()
        self.originalArticles = self.articles
        // console.log(self.articles)
      })
    },
    mounted () {
      let _this = this
      this.$nextTick(() => {
        window.fbAsyncInit = function () {

          window.FB.init({
            appId: '1530036100528440',
            xfbml: true,
            version: 'v3.2'
          })
          window.FB.AppEvents.logPageView()
          _this.FB = window.FB
          console.log('FB SDK was initialized as mixin')
          window.FB.XFBML.parse()
        };
        (function (d, s, id) {
          let js, fjs = d.getElementsByTagName(s)[0]
          if (d.getElementById(id)) { return }
          js = d.createElement(s); js.id = id
          js.src = '//connect.facebook.net/en_US/sdk.js'
          fjs.parentNode.insertBefore(js, fjs)
        }(document, 'script', 'facebook-jssdk'))
      })

      // console.log(window.FB)
      // console.log(window.FB.XFBML)
      // window.FB.XFBML.parse()
    },
    updated: function () {
      this.$nextTick(function () {
        // Code that will run only after the
        // entire view has been re-rendered
        // https://developers.facebook.com/docs/reference/javascript/FB.XFBML.parse/
        window.FB.XFBML.parse()
      })
    },
    methods: {
      isLocalhost () {
        return window.location.hostname === "localhost"
      },
      changeInputUrl () {
        this.isDuplicate = false
      },
      changedValue (value) {
        let self = this
        self.selectedArtists = []
        self.filterArticles()
        // console.log(value)
        // https://qiita.com/bbapexx/items/299521d49df0869dc44f
        db.ref('/articles').once('value').then(function (articles) {
          if (value === "登録順") {
            self.articles = []
            let _articles = articles.val()
            for (let index in _articles) {
              self.articles.push(_articles[index])
            }
            self.articles = self.articles.reverse()
            self.originalArticles = self.articles
          }
          else {
            self.articles = []
            let _articles = articles.val()
            for (let index in _articles) {
              if (_articles[index].publishedAt !== undefined) {
                self.articles.push(_articles[index])
              }
            }
            // https://qiita.com/PianoScoreJP/items/f0ff7345229871039672
            self.articles.sort(function(a, b){
              if (a.publishedAt < b.publishedAt) return -1
              if (a.publishedAt > b.publishedAt) return 1
              return 0
            })
            self.articles = self.articles.reverse()
            for (let index in _articles) {
              if (_articles[index].publishedAt === undefined) {
                self.articles.push(_articles[index])
              }
            }
            self.originalArticles = self.articles
          }

        })
      },
      filterArticles () {
        let self = this
        if (self.selectedArtists.length === 0) {
          self.articles = self.originalArticles
          return
        }

        self.articles = []
        for (let index in self.originalArticles) {
          let hit = true
          for (let sIndex in self.selectedArtists) {
            let artist = self.selectedArtists[sIndex]
            if (self.originalArticles[index].tags === undefined || self.originalArticles[index].tags.indexOf(artist) === -1) hit = false
            if (hit) self.articles.push(self.originalArticles[index])
          }
        }

      },
      getItemValue (bool) {
        return bool ? "はい" : "いいえ"
      },
      getSelectedItem (articleId, index) {
        // console.log(articleId, index, this.isSelectedArticleFree)
        let self = this
        self.articles[index].isFree = self.isSelectedArticleFree
        db.ref('/articles/' + articleId).set(self.articles[index]).then(function () {
        })
      },
      valueChange (value) {
        this.isSelectedArticleFree = value
      },
      adjustLength (description) {
        const descriptionLength = 140
        if (description && description.length > descriptionLength) {
          description = description.slice(0, descriptionLength) + '…'
        }
        return description
      },
      setArtist (articleInfo, index) {
        // console.log(articleInfo)
        let self = this
        self.articles[index].tags = articleInfo.tags
        db.ref('/articles/' + articleInfo.id).set(self.articles[index]).then(function () {
        })
      },
      remove (item) {
        this.chips.splice(this.chips.indexOf(item), 1)
        this.chips = [...this.chips]
        this.articles = this.originalArticles
      },
      isYouTubePlaylist (url) {
        // https://qiita.com/edisonthk/items/9e76784bedbd0cb969a5
        let parser = new URL(url)

        if (url.indexOf("playlist") !== -1) {
          let id = parser.searchParams.get("list")
          return id
        }

        return false
      },
      getNoteId (url) {
        // https://qiita.com/edisonthk/items/9e76784bedbd0cb969a5
        let parser = new URL(url)

        if (parser.host === "note.com") {
          let id = parser.pathname.split('/').pop()
          return id
        }

        return false
      },
      isTwitter (url) {
        let parser = new URL(url)
        return parser.host === "twitter.com"
      },
      getTweetId (url) {
        let parser = new URL(url)
        return parser.pathname.split('/').pop()
      },
      isFacebook (url) {
        let parser = new URL(url)
        return parser.host === "www.facebook.com" || parser.host === "fb.watch"
      },
      parseHtml (html) {
        return html.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'')
      },
      getYouTubeId (url) {
        // https://qiita.com/edisonthk/items/9e76784bedbd0cb969a5
        let parser = new URL(url)

        if (url.indexOf("youtu.be") !== -1) {
          let id = parser.pathname.split('/').pop()
          return id
        }

        if (url.indexOf("playlist") !== -1) {
          let id = parser.searchParams.get("list")
          return id
        }

        if (parser.host === "youtube.com") {
          let id = parser.searchParams.get("v")
          return id
        }

        return false
      },
      getPublishedAt (publishedAt) {
        return moment(publishedAt).format('LL')
      },
      getDuration (duration) {
        return moment.duration(duration).humanize({precision: 2})
      },
      submit () {
        // console.log(this.inputUrl)

        for (let ai in this.articles) {
          if (this.inputUrl === this.articles[ai].url) this.isDuplicate = true
        }
        if (this.isDuplicate) {
          console.log('そのURLは登録されています')
          return false
        }

        let self = this
        // console.log(self.inputUrl)
        // console.log(self.getYouTubeId(self.inputUrl))

        const CORS_PROXY = 'https://cors-anywhere.herokuapp.com/'
        let url = CORS_PROXY + this.inputUrl

        let id = self.getYouTubeId(self.inputUrl)
        let playListId = self.isYouTubePlaylist(self.inputUrl)
        let noteId = self.getNoteId(self.inputUrl)
        if (playListId) {
          let yurl = "https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=" + playListId + "&maxResults=50&key=" + youtubeKey
          fetch(yurl).then(res => res.text()).then(text => {
            let json = JSON.parse(text)
            let title = "YouTubeの再生リスト"
            let playListCount = json.items.length
            let firstItem = json.items[0]
            let thumbnail = firstItem.snippet.thumbnails.high.url
            // let description = playListCount + "個の動画が登録されています"
            let description = playListCount + "件の動画が登録されています。" + firstItem.snippet.description

            let newCommentRef = db.ref('/articles').push()
            newCommentRef.set({
              id: newCommentRef.key,
              siteName: "YouTube",
              index: Date.parse(new Date()) * -1,
              type: "youtube",
              title: title,
              description: description,
              ogimage: thumbnail,
              url: self.inputUrl,
              timestamp: Date.parse(new Date())
            }).then(function () {
              self.message = title + " を登録しました"
              self.inputUrl = ""
              db.ref('/articles').once('value').then(function (articles) {
                let _articles = articles.val()
                for (let index in _articles) {
                  self.articles.push(_articles[index])
                }

                self.articles = self.articles.reverse()
              })
              self.articles = []
            })

          })
        }
        else if (noteId) {
          let nurl = CORS_PROXY + "https://note.com/api/v1/notes/" + noteId
          fetch(nurl).then(res => res.text()).then(text => {
            let json = JSON.parse(text)
            // console.log(json)
            let title = json.data.name
            let publishedAt = json.data.created_at
            let thumbnail = json.data.eyecatch !== undefined ? json.data.eyecatch : json.data.user.user_profile_image_path
            let description = json.data.body

            let newCommentRef = db.ref('/articles').push()
            newCommentRef.set({
              id: newCommentRef.key,
              siteName: "note",
              publishedAt: publishedAt,
              index: Date.parse(new Date()) * -1,
              type: "note",
              title: title,
              description: description,
              ogimage: thumbnail,
              url: self.inputUrl,
              timestamp: Date.parse(new Date())
            }).then(function () {
              self.message = title + " を登録しました"
              self.inputUrl = ""
              db.ref('/articles').once('value').then(function (articles) {
                let _articles = articles.val()
                for (let index in _articles) {
                  self.articles.push(_articles[index])
                }

                self.articles = self.articles.reverse()
              })
              self.articles = []
            })

          })

        }
        else if (this.isTwitter(self.inputUrl)) {

          let newCommentRef = db.ref('/articles').push()
          newCommentRef.set({
            id: newCommentRef.key,
            siteName: "Twitter",
            index: Date.parse(new Date()) * -1,
            type: "Twitter",
            // title: title,
            // description: description,
            // ogimage: ogimage,
            url: self.inputUrl,
            timestamp: Date.parse(new Date())
          }).then(function () {
            self.message = "ツイートを登録しました"
            self.inputUrl = ""
            db.ref('/articles').once('value').then(function (articles) {
              let _articles = articles.val()
              for (let index in _articles) {
                self.articles.push(_articles[index])
              }

              self.articles = self.articles.reverse()
            })
            self.articles = []
          })

        }
        else if (this.isFacebook(self.inputUrl)) {

          fetch(url).then(res => res.text()).then(text => {
              const el = new DOMParser().parseFromString(text, "text/html")
              const headEls = (el.head.children)

              let title = ""
              let description = ""
              let ogimage = ""

              Array.from(headEls).map(v => {

                const prop = v.getAttribute('property')
                if (!prop) return;
                const content = v.getAttribute('content')
                if (!content) return
                if (prop === "og:site_name") console.log(content)
                if (prop === "og:title" || prop === "twitter:title") title = content
                // if (prop === "og:image" || prop === "twitter:card") title = content
                if (prop === "og:image") ogimage = content
                if (prop === "og:description" || prop === "twitter:description") description = content

              })

              let newCommentRef = db.ref('/articles').push()
              newCommentRef.set({
                id: newCommentRef.key,
                siteName: "Facebook",
                index: Date.parse(new Date()) * -1,
                type: "Facebook",
                title: title,
                description: description,
                ogimage: ogimage,
                url: self.inputUrl,
                timestamp: Date.parse(new Date())
              }).then(function () {
                self.message = title + " を登録しました"
                self.inputUrl = ""
                db.ref('/articles').once('value').then(function (articles) {
                  let _articles = articles.val()
                  for (let index in _articles) {
                    self.articles.push(_articles[index])
                  }

                  self.articles = self.articles.reverse()
                })
                self.articles = []
              })

            })
        }
        else if (id) {
          youtube.getById(id, function(error, result) {
            if (error) {
              console.log(error)
            }
            else {
              // console.log(result)
              // console.log(data.items)
              // console.log(item.thumbnails.default.url)

              let item = result.items[0]
              // console.log(publishedAt)
              // console.log(duration)
              // console.log(convertDuration)
              let title = item.snippet.title
              let newCommentRef = db.ref('/articles').push()
              newCommentRef.set({
                id: newCommentRef.key,
                siteName: "YouTube",
                publishedAt: item.snippet.publishedAt,
                index: Date.parse(new Date()) * -1,
                type: "youtube",
                title: item.snippet.title,
                description: item.snippet.description,
                ogimage: item.snippet.thumbnails.high.url,
                duration: item.contentDetails.duration,
                url: self.inputUrl,
                timestamp: Date.parse(new Date())
              }).then(function () {
                self.message = title + " を登録しました"
                self.inputUrl = ""
                db.ref('/articles').once('value').then(function (articles) {
                  let _articles = articles.val()
                  for (let index in _articles) {
                    self.articles.push(_articles[index])
                  }

                  self.articles = self.articles.reverse()
                })
                self.articles = []
              })

            }
          })
        }
        else {
          // https://qiita.com/ksyunnnn/items/bfe2b9c568e97bb6b494
          fetch(url).then(res => res.text()).then(text => {
              const el = new DOMParser().parseFromString(text, "text/html")
              const headEls = (el.head.children)

              let type = ""
              let title = ""
              let description = ""
              let ogimage = ""

              Array.from(headEls).map(v => {

                // console.log(v)
                const prop = v.getAttribute('property')
                if (!prop) return;
                // console.log(prop)
                const content = v.getAttribute('content')
                if (!content) return
                // console.log(content)
                if (prop === "og:site_name") console.log(content)
                if (prop === "og:type") type = content
                if (prop === "og:title" || prop === "twitter:title") title = content
                // if (prop === "og:image" || prop === "twitter:card") title = content
                if (prop === "og:image") ogimage = content
                if (prop === "og:description" || prop === "twitter:description") description = content

              })

              // console.log(type, title, description, ogimage)

              let newCommentRef = db.ref('/articles').push()
              newCommentRef.set({
                id: newCommentRef.key,
                index: Date.parse(new Date()) * -1,
                type: type,
                title: title,
                description: description,
                ogimage: ogimage,
                url: self.inputUrl,
                timestamp: Date.parse(new Date())
              }).then(function () {
                self.message = title + " を登録しました"
                self.inputUrl = ""
                db.ref('/articles').once('value').then(function (articles) {
                  let _articles = articles.val()
                  for (let index in _articles) {
                    self.articles.push(_articles[index])
                  }

                  self.articles = self.articles.reverse()
                })
                self.articles = []
              })

          })

        }

      }
    }
  }
</script>
